import { createRouter, createWebHistory } from 'vue-router';

import store from '@/store';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // ── Default: smart redirect based on auth state ───────────────────────────
    {
      path: '/',
      redirect: () => {
        const isAuthenticated = store.getters.getAuthStatus;
        return isAuthenticated ? '/postmanagement' : '/sign-in';
      },
    },

    // ── Sign-in (guest layout, no auth required) ──────────────────────────────
    {
      path: '/sign-in',
      name: 'sign-in',
      meta: { layout: 'guest', auth: false },
      component: () => import('../views/sign-in.vue'),
    },

    // ── Admin: Post Management & Group Invitation Codes ───────────────────────
    {
      path: '/postmanagement',
      name: 'postmanagement',
      meta: { layout: 'default', auth: true },
      component: () => import('../views/management/postmanagement.vue'),
    },

    // ── Embed test — tune SOCIAL_NATURAL offsetTop/offsetBottom values visually ─
    {
      path: '/embed-test',
      name: 'embed-test',
      meta: { layout: 'guest', auth: false },
      component: () => import('../views/embed-test.vue'),
    },

    // ── Catch-all: smart redirect based on auth state ────────────────────────
    // Any unknown URL (e.g. /sign-up, /home typed in address bar) goes directly
    // to the right place — no double-redirect.
    {
      path: '/:pathMatch(.*)*',
      redirect: () => {
        const isAuthenticated = store.getters.getAuthStatus;
        return isAuthenticated ? '/postmanagement' : '/sign-in';
      },
    },

    // ── COMMENTED: all launch_pad_fe routes (not needed for admin panel) ──────
    // { path: '/search', name: 'search', meta: { layout: 'default', auth: true }, component: () => import('../views/search.vue') },
    // { path: '/modern-feed', name: 'modern-feed', meta: { layout: 'default', auth: true }, component: () => import('../views/ModernFeedView.vue') },
    // { path: '/sign-in-with-x', name: 'sign-in-with-x', meta: { layout: 'guest', auth: false }, component: () => import('../views/sign-in-with-x.vue') },
    // { path: '/oauth-callback-bluesky', name: 'oauth-callback-bluesky', meta: { layout: 'guest', auth: false }, component: () => import('../views/oauth-callback-bluesky.vue') },
    // { path: '/declaration', name: 'declarationPage', meta: { layout: 'guest', auth: false }, component: () => import('../views/declarationPage.vue') },
    // { path: '/about', name: 'aboutPage', meta: { layout: 'default', auth: true }, component: () => import('../views/about/aboutus.vue') },
    // { path: '/privacy', name: 'privacy', meta: { layout: 'default', auth: true }, component: () => import('../views/about/privacy.vue') },
    // { path: '/term-of-service', name: 'terms', meta: { layout: 'default', auth: true }, component: () => import('../views/about/terms.vue') },
    // { path: '/post/:id', name: 'post', meta: { layout: 'default', auth: true }, component: () => import('../views/post.vue') },
    // { path: '/reply/:id', name: 'reply', meta: { layout: 'default', auth: true, isReply: true }, component: () => import('../views/post.vue') },
    // { path: '/profile/:id', name: 'profile', meta: { layout: 'default', auth: true }, component: () => import('../views/profile.vue') },
    // { path: '/user/:username', name: 'username', meta: { layout: 'default', auth: true }, component: () => import('../views/profile.vue') },
    // { path: '/group/:id', name: 'org', meta: { layout: 'default', auth: true }, component: () => import('../views/org.vue') },
    // { path: '/groups', name: 'groups', meta: { layout: 'default', auth: true }, component: () => import('../views/groups.vue') },
    // { path: '/groups/:userId', name: 'user-groups', meta: { layout: 'default', auth: true }, component: () => import('../views/groups.vue') },
    // { path: '/user/dougjones-help', name: 'dougjones-help', meta: { layout: 'default', auth: false }, component: () => import('../views/dougjones-help.vue') },
    // { path: '/group/:groupId/channel/:id', name: 'channel', meta: { layout: 'default', auth: true }, component: () => import('../views/channel.vue') },
    // { path: '/followers/:id', name: 'followers', meta: { layout: 'default', auth: true }, component: () => import('../views/followers.vue') },
    // { path: '/following/:id', name: 'following', meta: { layout: 'default', auth: true }, component: () => import('../views/followers.vue') },
    // { path: '/notifications', name: 'notifications', meta: { layout: 'default', auth: true }, component: () => import('../views/notifications.vue') },
    // { path: '/twoFactorAuth', name: 'twoFactorAuth', meta: { layout: 'default', auth: true }, component: () => import('../views/twoFactorAuth.vue') },
    // { path: '/sign-up', name: 'signup', meta: { layout: 'guest', auth: false }, component: () => import('../views/onboarding/SignUp.vue') },
    // { path: '/onboarding/verification-code', name: 'verification-code', meta: { layout: 'guest', auth: false }, component: () => import('../views/onboarding/VerificationCode.vue') },
    // { path: '/onboarding/create-password', name: 'create-password', meta: { layout: 'guest', auth: false }, component: () => import('../views/onboarding/CreatePassword.vue') },
    // { path: '/onboarding/add-avatar', name: 'add-avatar', meta: { layout: 'guest', auth: false }, component: () => import('../views/onboarding/AddAvatar.vue') },
    // { path: '/onboarding/login-method', name: 'login-method', meta: { layout: 'guest', auth: false }, component: () => import('../views/onboarding/LoginMethod.vue') },
    // { path: '/siwf/callback', name: 'siwf-callback', meta: { layout: 'guest', auth: false }, component: () => import('../views/siwf-callback.vue') },
    // { path: '/siwf-login', name: 'siwf-login', meta: { layout: 'guest', auth: false }, component: () => import('../views/siwf-login.vue') },
    // { path: '/siwf/register', name: 'siwf-register', meta: { layout: 'guest', auth: false }, component: () => import('../views/siwf-register.vue') },
    // { path: '/verify-email', name: 'verify-email', meta: { layout: 'guest', auth: false }, component: () => import('../views/verify-email.vue') },
    // { path: '/l/:id', name: 'check-visit-links', meta: { layout: 'guest', auth: false }, component: () => import('../views/check-visit-links.vue') },
  ],
});

router.beforeEach((to, from, next) => {
  try { store.commit('setRouteLoading', true); } catch {}

  const isAuthenticated = store.getters.getAuthStatus;

  // Not authenticated → send to sign-in
  if (!isAuthenticated && to.meta.auth) {
    next('/sign-in');
    return;
  }

  // Already authenticated → skip sign-in, go straight to admin panel
  if (isAuthenticated && to.name === 'sign-in') {
    next('/postmanagement');
    return;
  }

  next();
});

router.afterEach(() => {
  try { store.commit('setRouteLoading', false); } catch {}
});

router.onError(() => {
  try { store.commit('setRouteLoading', false); } catch {}
});

/**
 * Navigate back to the Post Management admin page.
 * Used as a shared "go back" utility by any view that needs to return to the
 * main admin dashboard without relying on browser history (which may not exist
 * if the user deep-linked directly to a sub-page).
 */
export function goBack() {
  router.push('/postmanagement');
}

export default router;
